import { render, staticRenderFns } from "./FormDependenciesList.vue?vue&type=template&id=1cbd2c1f"
import script from "./FormDependenciesList.vue?vue&type=script&lang=ts"
export * from "./FormDependenciesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports